import DataApi from "./DataApi";

class SearchViewApi extends DataApi {
  constructor() {
    super("objectconfig/searchviews");
  }

  /**
   * Fetch all search views
   */
  async fetchAll() {
    return await this.get("");
  }

  /**
   * Get objects with search view status
   */
  async getObjectsWithStatus() {
    return await this.get("/objects");
  }

  /**
   * Fetch search view by object name
   * @param {string} objectName - The object name
   */
  async fetchByObjectName(objectName) {
    return await this.get(`/object/${objectName}`);
  }

  /**
   * Fetch search view by ID
   * @param {string} id - Search view ID
   */
  async fetchById(id) {
    return await this.get(`/${id}`);
  }

  /**
   * Create a new search view
   * @param {Object} searchViewData - Search view data
   */
  async create(searchViewData) {
    return await this.post("", searchViewData);
  }

  /**
   * Update an existing search view
   * @param {string} id - Search view ID
   * @param {Object} updateData - Updated search view data
   */
  async update(id, updateData) {
    return await this.put(`/${id}`, updateData);
  }

  /**
   * Delete a search view (soft delete)
   * @param {string} id - Search view ID
   */
  async delete(id) {
    return await this.delete(id);
  }
}

export default SearchViewApi;
